import React from 'react';

import { PROJECTS_CONFIG } from '@/appConstants';
import Icon from '@/components/Shared/Icon';
import { colorSurfaceButton } from '@/styleUtils';

import {
  Button,
  ButtonsGroup,
  FullHeightWrapper,
  StyledText,
  StyledTitle,
} from './style';

const multiButtons = [
  {
    name: 'emptyPhone',
    color: colorSurfaceButton,
    link: 'tel:0800307555',
    text: PROJECTS_CONFIG.multi.phone,
  },
  {
    name: 'viber',
    color: '#764D97',
    link: 'viber://pa?chatURI=insure_robot',
  },
  { name: 'telegram', color: '#0088CC', link: 'https://t.me/insure_robot' },
];

export function MultiMainSection() {
  return (
    <FullHeightWrapper>
      <Icon name="brokenLaptop" width={164} />
      <StyledTitle>Щось пішло не так</StyledTitle>
      <StyledText>Зв’яжіться з нами — з усім допоможемо.</StyledText>
      <ButtonsGroup>
        {multiButtons.map(({ name, link, color, text }) => (
          <Button
            key={name}
            $color={color}
            href={link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name={name} width={24} />
            {text || ''}
          </Button>
        ))}
      </ButtonsGroup>
    </FullHeightWrapper>
  );
}

export default MultiMainSection;
